import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { DateFilterTemplate } from "./Grid/ColumnFilterTemplates";

interface Props {
  showButtonBar?: boolean;
  options: ColumnFilterElementTemplateOptions;
  placeholder?: string;
}

export function DateFilter(props: Props) {
  return (
    <DateFilterTemplate
      showButtonBar={props.showButtonBar}
      onChange={(e) => props.options.filterApplyCallback(e.value)}
      placeholder={props.placeholder}
    />
  );
}
